<ng-container>
  <q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

  <ng-container *ngIf="!(loading$ | async)">
    <mat-dialog-content class="content">
      <items-selector
        [displayValueField]="'displayValue'"
        [availableItemsTitle]="'RUBIC_CUBE.COLUMNS_AVAILABLE'"
        [filterPlaceholder]="'RUBIC_CUBE.FILTER_COLUMNS'"
        [selectedItemsTitle]="'RUBIC_CUBE.COLUMNS_DISPLAYED'"
        [availableItems]="availableColumns"
        [selectedItems]="selectedColumns"
        [showSelectAll]="true"
        (validateSelectedItems$)="validate()"></items-selector>
    </mat-dialog-content>

    <mat-dialog-actions class="right-side">
      <q9-secondary-button (click)="$event.preventDefault(); cancel()" [color]="'primary'">
        {{ cancelBtn | translate }}
      </q9-secondary-button>

      <q9-primary-button [color]="'primary'" (click)="confirm()" [disabled]="!isValid">
        {{ confirmBtn | translate }}
      </q9-primary-button>
    </mat-dialog-actions>
  </ng-container>
</ng-container>
